<template>
  <div class="mp">
    <div class="mpbanner"></div>
    <van-tabs
      :ellipsis="false"
      swipeable
      sticky
      v-model="activeName"
      @change="tabchange"
    >
      <van-tab v-for="(i, j) in tabslist" :title="i.name" :key="j">
        <div class="mpsecnav" v-if="i.children.length > 0">
          <div
            class="mpsecnavsingle"
            v-for="(k, l) in i.children"
            :key="l"
            @click="navclick(k, l)"
            :style="{
              background: activeNames == l ? 'rgba(25, 97, 172, 1)' : '#fff',
              border:
                activeNames == l
                  ? '1px solid rgba(25, 97, 172, 1)'
                  : '1px solid rgba(6, 25, 45, 0.5)',
              color: activeNames == l ? '#fff' : 'rgba(6, 25, 45, 0.6)',
            }"
          >
            {{ k.name }}
          </div>
        </div>
        <div class="mpseccon">
          <div
            class="mpsecconsingle"
            v-for="(g, h) in datalist"
            :key="h"
            :style="{
              background: ` url(${g.url})`,
            }"
            @click="previewimg(g.url, g.title)"
          >
            <div class="mask">
              {{ g.title }}
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <el-dialog :visible.sync="showimg" width="90%">
      <div class="previewcon">
        <div class="dialogbg">
          <img style="width: 100%; height: auto" :src="imgurl" alt="" />
        </div>
        <p
          style="
            font-size: 14px;
            text-align: center;
            width: 100%;
            margin-bottom: 5.33vw;
          "
        >
          {{ showname }}
        </p>
      </div>
      <div class="mcancel">
        <img
          src="../../assets/image/mcancel.png"
          alt=""
          style="width: 10.67vw; height: 10.67vw"
          @click="showimg = false"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showimg: false,
      imgurl: "",
      showname: "",
      tabslist: [
        {
          name: "施工总承包",
          index: 0,
          children: [
            {
              name: "铁路站房",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "调度所及铁路配套工程",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "机场",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "文化场馆",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "体育场馆",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "学校",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "地产住宅",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "医疗养老",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "政府办公",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "城市综合体",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "科研基地和研发中心",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
          ],
        },
        {
          name: "工程总承包",
          index: 1,
          children: [],
          content: [
            { name: "雄安站", icon: require("../../assets/image/case8.png") },
            { name: "雄安站", icon: require("../../assets/image/case2.png") },
            { name: "雄安站", icon: require("../../assets/image/case3.png") },
            { name: "雄安站", icon: require("../../assets/image/case4.png") },
            { name: "雄安站", icon: require("../../assets/image/case5.png") },
            { name: "雄安站", icon: require("../../assets/image/case6.png") },
          ],
        },
        {
          name: "基础设施",

          index: 2,
          children: [
            {
              name: "铁路交通",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
              ],
            },
            {
              name: "轨道交通",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
          ],
        },
        {
          name: "建筑工业化",
          index: 3,
          children: [],
          content: [
            { name: "雄安站", icon: require("../../assets/image/case8.png") },
            { name: "雄安站", icon: require("../../assets/image/case2.png") },
            { name: "雄安站", icon: require("../../assets/image/case3.png") },
            { name: "雄安站", icon: require("../../assets/image/case4.png") },
          ],
        },
        {
          name: "专业领域",
          index: 4,
          children: [
            {
              name: "装饰",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
              ],
            },
            {
              name: "安装",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
              ],
            },
            {
              name: "绿色产业",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "科技创新",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case3.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case4.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
            {
              name: "机械",
              content: [
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case1.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case2.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case5.png"),
                },
                {
                  name: "雄安站",
                  icon: require("../../assets/image/case6.png"),
                },
              ],
            },
          ],
        },
      ],
      activeName: 0,
      activeNames: 0,
      datalist: [],
      navindex: 0,
    };
  },
  mounted() {
    this.returnpath(0);
  },
  methods: {
    changelast(e) {
      let arr = [];
      arr = this.navname.split("/");
      arr.pop();
      arr.push(e);
      this.navname = arr.join("/");
      this.getlist();
    },
    previewimg(e, v) {
      this.showimg = true;
      this.imgurl = e;
      this.showname = v;
    },
    tabchange(e) {
      this.returnpath(e);
      this.activeNames = 0;
    },
    navclick(e, index) {
      this.changelast(e.name);
      this.activeNames = Number(index);
    },
    async getlist() {
      let data = {
        category: this.navname,
      };
      const res = await this.$http.plist(data);
      if (res.code == 200) {
        this.datalist = res.data;
      } else {
        // 处理错误情况
        console.log("Error fetching news list:", res.data.msg);
      }
    },
    returnpath(e) {
      this.navindex = e;
      for (let i in this.tabslist) {
        if (e == this.tabslist[i].index) {
          if (e % 2 === 0) {
            this.navname = `产品系列/${this.tabslist[i].name}/${this.tabslist[i].children[0].name}`;
            this.getlist();
          } else {
            this.navname = `产品系列/${this.tabslist[i].name}`;
            this.getlist();
          }
        }
      }
    },
  },

  watch: {
    $route(to, from) {
      this.activeName = Number(to.query.index);
    },
  },
};
</script>

<style lang="less" scoped>
.mp {
  .mpseccon {
    .mpsecconsingle {
      .mask {
        width: 100%;
        height: 14.4vw;
        background: linear-gradient(
          180deg,
          rgba(6, 25, 45, 0) 0%,
          rgba(6, 25, 45, 0.6) 82%
        );
        line-height: 14.4vw;
        padding: 0 4vw;
        color: white;
        font-size: 14px;
      }
      width: 100%;
      height: 56vw;
      margin-bottom: 2.67vw;
      display: flex;
      justify-content: left;
      align-items: flex-end;
    }
    width: 100%;
    padding: 3.2vw 4vw;
    background: #fff;
  }
  .mpsecnav {
    .mpseccon {
      .mpsecconsingle {
        .mask {
          width: 100%;
          height: 14.4vw;
          background: linear-gradient(
            180deg,
            rgba(6, 25, 45, 0) 0%,
            rgba(6, 25, 45, 0.6) 82%
          );
          line-height: 14.4vw;
          padding: 0 4vw;
          color: white;
          font-size: 14px;
        }
        width: 100%;
        height: 56vw;
        margin-bottom: 2.67vw;
        display: flex;
        justify-content: left;
        align-items: flex-end;
      }
      width: 100%;
      padding: 3.2vw 4vw;
      background: #fff;
    }
    .mpsecnavsingle {
      padding: 2.13vw 2.67vw;
      border: 1px solid rgba(6, 25, 45, 0.5);
      font-size: 12px;
      // line-height: 14px;
      color: rgba(6, 25, 45, 0.6);
      border-radius: 1.07vw;
    }
    width: 100%;
    background: #f4f6f9;
    padding: 3.2vw 5vw;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 3.2vw;
  }
  .mpbanner {
    width: 100%;
    height: 42.67vw;
    background: url("https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/mproducttop.png")
      no-repeat;
    background-position: 0 0;
    background-size: 100% 100%;
  }
  width: 100%;
}
.mcancel {
  width: 100%;
  height: 10.67vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.previewcon {
  .dialogbg {
    width: 100%;
    background: rgba(247, 249, 252, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2.67vw;
    padding: 3.2vw;
  }
  width: 100%;
  background: rgba(247, 249, 252, 1);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 3.73vw;
  margin-bottom: 5.33vw;
}
::v-deep .van-tab--active {
  color: #1961ac !important;
  // font-size: 4vw;
}
::v-deep .van-tabs__line {
  // width: 100%;
  background-color: rgba(22, 104, 188, 1);
}
::v-deep .van-tabs__line {
  width: 60px;
  height: 2px;
  border-radius: 4px 4px 0 0;
  background: #1668bc;
  opacity: 1;
  color: #1668bc;
}
::v-deep .el-dialog {
  background: transparent;
  box-shadow: unset;
}
::v-deep .el-dialog__header {
  display: none;
}
::v-deep .el-dialog__body {
  background: transparent;
  height: 114.67vw;
  padding: 0;
}
::v-deep .el-icon-close {
  font-size: 1.88vw !important;
  color: rgba(0, 0, 0, 0.6) !important;
  line-height: 1.88vw;
}
::v-deep .el-dialog__headerbtn {
  top: 1.15vw;
}
</style>
